import { Navigate, useParams } from 'react-router-dom'

const HowIEatProgress: React.FC = () => {
  const { spaceId } = useParams<{ spaceId: string }>()
  return <Navigate to={`/how-i-eat/${spaceId}?tab=stats`} replace />
}

export default HowIEatProgress
